import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import "./LeagueGroupsModal.css";
import close from "../../../../../../../assets/close.svg";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { messages } from "../../../../../../../messages.js";
import { config, PREFERRED_TIME_LIST, REGISTERED_THROUGH_CLEVELAND, REGISTERED_THROUGH_MULBERRY } from "../../../../../../../config";
import CustomSelect from '../../../../../../../Util/CustomSelect/CustomSelect';
import { validateRequiredFields } from '../../../../../../../Util/helper';
import debounce from "lodash.debounce";
import WarningDialogue from '../../../../../../../Util/WarningDialogue';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import NumberFormat from 'react-number-format';

export default function LeagueGroupsAdd(props) {
  const history = useHistory();
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({});
  const [duplicateName, setDuplicateName] = useState(false);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const [errors, setErrors] = useState({
    name: '',
    preferred_time: '',
  });
  useEffect(() => {
    setFormData({
      preferred_time: '',
      name: '',
      total_fees: 0,
      registration_fees: props?.leagueData?.reg_fees,
      for_feit_fees: props?.leagueData?.for_feit_fees,
      league_id: props.league_id,
      imported_from: props.hosted_by ? props.hosted_by === 'mulberry' ? REGISTERED_THROUGH_MULBERRY : REGISTERED_THROUGH_CLEVELAND : null,
    });
    // eslint-disable-next-line
  }, [props.hosted_by]);

  const closeModal = () => {
    if (props.closeModal) {
      props.closeModal();
    }
  }

  const handleFormChange = (event) => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      [event.target.name]: event.target.value,
    }))
  }

  const checkSchedule = (event) => {
    event.preventDefault();
    if (props.scheduleCount && props.scheduleCount > 0) {
      handleFormSubmit();
    } else {
      if (props.closeModal) {
        props.closeModal();
      }
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    if (props.scheduleCount && props.scheduleCount > 0) {
      checkProperSchedule();
    } else {
      handleFormSubmit();
    }
  }

  const checkProperSchedule = () => {
    axiosApi.get(`${config.apiUrl}/teams/check/scheduling/${props.league_id}?action=add`)
      .then((response) => {
        if (!response.data.properScheduling) {
          setOpenWarningPopup(true);
          setPopUpContent({
            header: 'Confirm',
            description: response.data.message,
            icon: faExclamationTriangle,
            action: () => {
              setOpenWarningPopup(false);
              setTimeout(() => {
                history.push({
                  pathname: `/admin/leagues/teams/league-settings`,
                  search: `?leagueId=${props.league_id}&selected=true${(season_id) ? `&season_id=${season_id}` : ''}`,
                })
              }, 100);
            }
          });
        } else {
          handleFormSubmit(true);
        }
      })
      .catch((err) => {
        handleFormSubmit(true);
      })

  }

  const handleValidation = () => {
    let errorArr = {};
    let formIsValid = true;

    if (!formData['preferred_time']) {
      formIsValid = false;
      errorArr["preferred_time"] = messages && messages.emptyTitle;
    }
    if (!formData.name?.trim()) {
      formIsValid = false;
      errorArr['name'] = messages && messages.emptyNoOfMatch;
    }

    setErrors(errorArr);
    return formIsValid;
  }

  const handleFormSubmit = (schedule = false) => {
    setFormSubmitted(true);
    if (!handleValidation() || duplicateName) {
      return;
    }
    setFormSubmitted(false);
    const data = { ...formData };
    data.schedule = schedule;
    if (data) {
      data.name = data.name?.trim();
    }
    axiosApi.post(`${config.apiUrl}/teams`, data)
      .then((response) => {
        if (props.getTeams) {
          props.getTeams();
        }
        if (response.data && response.data.conflicts) {
          if (props.conflicts) {
            props.conflicts();
          }
        }
        closeModal();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  // Check duplicate team name
  const checkDuplicateTeamName = (e) => {
    handleFormChange(e);
    // const postData = {
    //     league_id: props.league_id, 
    //     name: e.target.value,
    // };
    // if(e.target.value) {
    //     axiosApi.post(`${config.apiUrl}/misc/check-team-duplicate`, postData)
    //     .then((res) => {
    //         if(res.data && res.data.data) {
    //             setDuplicateName(true);
    //         } else {
    //             setDuplicateName(false);
    //         }
    //     })
    //     .catch((error) => {
    //         setDuplicateName(false);
    //     });
    // }
  }
  const debouncedSearch = debounce(checkDuplicateTeamName, 800);
  
  useEffect(() => {
    handleValidation();
  }, [formData])
  return <>
    <div className="modal">
      <div className="modal-header">
        <h2>Add Team</h2>
        <p>Enter team details, Players can be added after creation.</p>
        <span className="close" onClick={closeModal}>
          <img src={close} alt='close-icon' />
        </span>
      </div>
      <form onSubmit={handleSubmit} autoComplete='off'>
        <div className="addTeam-Modal">
          <div className="display-flex-none input-field">
            <CustomSelect
              className="display-flex-none"
              key={'preferred-time-team-add'}
              data={PREFERRED_TIME_LIST}
              label="Preferred Time"
              placeholder={'Select preferred time'}
              type="sport"
              onSelect={(selected) => {
                if (selected && selected.id) {
                  handleFormChange({
                    target: {
                      name: 'preferred_time',
                      value: selected.id,
                    }
                  })
                }
              }}
              selector="title"
            />
            {formSubmitted && !formData.preferred_time && <span className="error">{messages.emptyTime}</span>}
          </div>
          <div className="input-field">
            <label>Team Name</label>
            <input type="text" name="name" placeholder="Enter team name" onChange={(e) => { debouncedSearch(e); }} />
            {formSubmitted && !(formData.name || '').trim() && <span className="error">{messages.emptyTeamName}</span>}
            {formData.name && formData.name.trim() && duplicateName && <span className="error">{messages.duplicateTeamName}</span>}
          </div>
          <div className="input-field">
            <label>Registration Fees</label>
            <NumberFormat
              placeholder=" "
              onValueChange={(e) => {}}
              value={props?.leagueData?.reg_fees}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              thousandsGroupStyle={['thousand']}
              thousandSeparator={true}
              disabled={true}
              prefix='$'
              name="reg_fees"
              autoComplete="off"
            />
          </div>
          <div className="input-field">
            <label>Paid Amount</label>
            <NumberFormat
              placeholder=" "
              onValueChange={(e) => handleFormChange({ target: { name: 'total_fees', value: e.floatValue } })}
              value={formData?.total_fees}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              thousandsGroupStyle={['thousand']}
              thousandSeparator={true}
              disabled={false}
              prefix='$'
              name="total_fees"
              autoComplete="off"
            />
          </div>
        </div>
        <div className="modal-footer d-flex">
          <button className="cancel-btn" onClick={checkSchedule}>{props.scheduleCount && props.scheduleCount > 0 ? 'Add Without Schedule' : 'Cancel'}</button>
          <button type="submit">{props.scheduleCount && props.scheduleCount > 0 ? 'Add With Schedule' : 'Confirm'}</button>
        </div>
      </form>
    </div>
    <WarningDialogue
      isOpen={openWarningPopup}
      header={popUpContent.header}
      description={popUpContent.description}
      icon={popUpContent.icon}
      action={popUpContent.action}
      onClose={() => { setOpenWarningPopup(false); }}
    />
  </>
}